/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_DescriptionInputs */

const en_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select your media source and enter a project name.`)
};

const fr_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner votre source media et entrer un nom de projet.`)
};

const de_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie Ihre Medienquelle aus und geben Sie einen Projektnamen ein.`)
};

const it_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la fonte multimediale e inserisci un nome per il progetto.`)
};

const ru_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите источник медиафайлов и введите название проекта.`)
};

const es_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione su fuente de medios e ingrese un nombre de proyecto.`)
};

const zh_cn2_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择您的媒体来源并输入项目名称。`)
};

const ja_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア ソースを選択し、プロジェクト名を入力してください。`)
};

const hi_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया अपना मीडिया स्रोत चुनें और प्रोजेक्ट का नाम दर्ज करें।`)
};

const pt_pt2_new_project_description = /** @type {(inputs: New_Project_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione sua fonte de mídia e insira o nome do projeto.`)
};

/**
* | output |
* | --- |
* | "Please select your media source and enter a project name." |
*
* @param {New_Project_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_description = /** @type {((inputs?: New_Project_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_description(inputs)
	if (locale === "de") return de_new_project_description(inputs)
	if (locale === "it") return it_new_project_description(inputs)
	if (locale === "ru") return ru_new_project_description(inputs)
	if (locale === "es") return es_new_project_description(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_description(inputs)
	if (locale === "ja") return ja_new_project_description(inputs)
	if (locale === "hi") return hi_new_project_description(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_description(inputs)
	return en_new_project_description(inputs)
});